import {HttpError} from "./HttpError";

const GET_SHARE_IMAGE_ATTEMPTS = 3;

export default async function getShareImage(apiEndpoint: string, template: string, params: any) {
    const url = apiEndpoint.replace('{template}', template);
    const request: RequestInit = {
        method: "POST",
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
    };

    let attempt = GET_SHARE_IMAGE_ATTEMPTS;
    while (attempt--) {
        const response = await fetch(url, request);

        if (!response.ok) {
            throw new HttpError("Api request failed", {
                url,
                request,
                response
            });
        }

        const dataUri = await response.text();
        if (dataUri.length > 40) {
            return dataUri;
        }
    }

    throw new HttpError("Invalid share image", {
        url,
        request,
    });
}